<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { post } from './utils/request' // 引入请求
export default {
  data () {
    return {

    }
  },
  created () {
    // if (!this.$store.state.user.token) {
    //   post('home/getToken', {
    //     authentication: 'mall01'
    //   }, res => {
    //     this.$store.commit('setState', {
    //       user: res.result.data.id,
    //       token: res.result.data.token
    //     })
    //   })
    // }
  },
  methods: {},
  beforeCreate () {
    // 判断是刷新浏览器还是关闭页面
    if (!window.sessionStorage.getItem('flag')) {
      // 关闭页面
      // this.$store.dispatch('LOGOUT')
      // console.log(window.sessionStorage.getItem('flag'))
    } else {
      // 刷新浏览器
      // console.log(window.sessionStorage.getItem('flag'))
    }
  }
}
</script>
<style lang="scss">
html {
  padding: 0;
  margin: 0;
}
body {
  padding: 0;
  margin: 0;
  min-width: 100%;
  background-color: #f4f4f4;
}
@font-face {
  font-family: '朦胧黑体';
  src: url(./assets/Medium.ttf);
}
* {
  padding: 0;
  margin: 0;
  font-family: '微软雅黑';
}
// 隐藏滚动条样式
.qp-scrollbar .el-scrollbar__wrap {
  width: 150%;
  overflow-x: hidden;
}

// 下拉框最大高度
.el-select-dropdown__wrap {
  max-height: 310px !important;
}
</style>
